import { Message } from 'element-ui';

import router from '@/router';
import Config from '@/util/config';
import DevConfig from '@/util/config';
import qs from 'qs';
import axios, { AxiosInstance } from 'axios';
import { ClassApi, ClassHourApi, Configuration, CoreApi, UserApi } from '@orbitxedu/client-orbitxedu-typescript-axios';

interface Result<T> {
  code: number;

  message: string;

  success: boolean;

  timestamp: number;

  data: T;
}

export function requestJapi<T>(url: string, object: unknown, method: string): Promise<Result<T>> {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open(method, Config.jhost + url);

    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    if (!url.includes('login')) {
      xhr.setRequestHeader('token', localStorage.getItem('token')!);
    }

    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(qs.stringify(object));
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const res = JSON.parse(xhr.responseText);
        if (res.code == 1003) {
          Message({ message: '用户信息过期请重新登陆', type: 'error', duration: 5000 });
          router.push('/login');
        } else {
          resolve(res);
        }
      }
    };
  });
}

export class Api {
  private static _instance: Api;

  public static get current() {
    return this._instance || (this._instance = new Api());
  }

  private static createConfiguration() {
    return new Configuration({
      basePath: DevConfig.jhost?.replace(/\/$/, ''),
      // baseOptions: {
      //   headers: {
      //     get Token() {
      //       return localStorage.getItem('token');
      //     },
      //   },
      // },
    });
  }

  private static createAxiosInstance(): any {
    const service = axios.create({});
    service.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Token = token;
      }

      return config;
    });
    service.interceptors.response.use(
      (response) => {
        if (response.data && 'code' in response.data && response.data.code !== 200) {
          Message({
            message: response.data.message,
            type: 'error',
            duration: 5000,
          });
          return Promise.reject(response.data.message);
        }
        return response;
      },
      (error) => {
        Message({
          message: error?.response?.data?.message || error.message,
          type: 'error',
          duration: 5000,
        });
        return Promise.reject(error);
      },
    );
    return service;
  }

  private constructor(
    config: Configuration = Api.createConfiguration(),
    axiosInstance: AxiosInstance = Api.createAxiosInstance(),
    public readonly classHourApi: ClassHourApi = new ClassHourApi(config, undefined, axiosInstance),
    public readonly coreApi = new CoreApi(config, undefined, axiosInstance),
    public readonly userApi = new UserApi(config, undefined, axiosInstance),
    public readonly classApi = new ClassApi(config, undefined, axiosInstance),
  ) {}
}
